import { Link } from 'react-router-dom';
import { useState } from 'react';
import '../Styles/header.css';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null); // 'about' | 'platforms' | null

  const toggleMenu = () => setMenuOpen((prev) => !prev);
  const closeMenu = () => {
    setMenuOpen(false);
    setOpenDropdown(null);
  };

  const toggleDropdown = (name) => {
    setOpenDropdown((prev) => (prev === name ? null : name));
  };

  return (
    <header className="header">
      <div className="header-logo">
        <Link to="/" onClick={closeMenu}>
          <img
            src="/assets/vnkm_logo.png"
            alt=""
            className="logo-img"
          />
        </Link>
      </div>

      <div className="header-right">
        <nav className={`header-nav ${menuOpen ? 'active' : ''}`}>
          <Link to="/" className="nav-link" onClick={closeMenu}>Home</Link>

          <div className="nav-item-dropdown">
            <button
              type="button"
              className="nav-link dropdown-toggle"
              onClick={() => toggleDropdown('about')}
              aria-expanded={openDropdown === 'about'}
            >
              About us
              <img
              src="/assets/Header_arrow_icon.png"
              alt="Dropdown Arrow"
              className={`dropdown-chevron ${openDropdown === 'about' ? 'open' : ''}`}
            />
            </button>

            {openDropdown === 'about' && (
              <div className="dropdown-menu">
                <span className="dropdown-caret"></span>
                <Link to="/about" className="dropdown-link" onClick={closeMenu}>
                  What We Do
                </Link>
                <Link to="/ourteam" className="dropdown-link" onClick={closeMenu}>
                  Our Team
                </Link>
                <Link to="/ourpartner" className="dropdown-link" onClick={closeMenu}>
                  Our Partners
                </Link>
              </div>
            )}
          </div>

          <div className="nav-item-dropdown">
            <button
              type="button"
              className="nav-link dropdown-toggle"
              onClick={() => toggleDropdown('platforms')}
              aria-expanded={openDropdown === 'platforms'}
            >
              Our Platforms
              <img
              src="/assets/Header_arrow_icon.png"
              alt="Dropdown Arrow"
              className={`dropdown-chevron ${openDropdown === 'platforms' ? 'open' : ''}`}
            />
            </button>

            {openDropdown === 'platforms' && (
              <div className="dropdown-menu">
                <span className="dropdown-caret"></span>
                <Link to="/hrcom" className="dropdown-link" onClick={closeMenu}>
                  HR Community Network
                </Link>
                <Link to="/industry" className="dropdown-link" onClick={closeMenu}>
                  Industry-Academia Connect
                </Link>
                <Link to="/branding" className="dropdown-link" onClick={closeMenu}>
                  Employer Branding & Recognition
                </Link>
              </div>
            )}
          </div>


          <Link to="/get-certified" className="nav-link" onClick={closeMenu}>Get Certified</Link>
          <Link to="/eventspage" className="nav-link" onClick={closeMenu}>Events</Link>
          <Link to="/gallery" className="nav-link" onClick={closeMenu}>Gallery</Link>

          <div className="header-cta mobile-cta">
            <Link to="/join" className="join-btn" onClick={closeMenu}>
              Join Our Community
              <img
                src="/assets/home_arrow_icon.png"
                alt="Arrow Icon"
                className="arrow-icon"
              />
            </Link>
          </div>
        </nav>

        <div className="header-cta desktop-cta">
          <Link to="/join" className="join-btn">
            Join Our Community
              <img
                src="/assets/home_arrow_icon.png"
                alt="Arrow Icon"
                className="arrow-icon"
              />
          </Link>
        </div>
      </div>

      <button
        className={`burger-btn ${menuOpen ? 'open' : ''}`}
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
        aria-expanded={menuOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {menuOpen && <div className="nav-overlay" onClick={closeMenu}></div>}
    </header>
  );
}

export default Header;
